import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import setup from './setup'
import payment from './payment'
import platform from './platform'
import dashboard074181 from './dashboard'
import onboardingTour from './onboarding-tour'
import members79483b from './members'
import contributions49f328 from './contributions'
import inbox43de3a from './inbox'
import campaigns from './campaigns'
import automations from './automations'
import plans from './plans'
import profile from './profile'
import community from './community'
import posts from './posts'
import bundles from './bundles'
import team4b9005 from './team'
/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/app/creator',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\DashboardController::__invoke
* @see app/Http/Controllers/Creator/DashboardController.php:22
* @route '/app/creator'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
export const members = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: members.url(options),
    method: 'get',
})

members.definition = {
    methods: ["get","head"],
    url: '/app/creator/members',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
members.url = (options?: RouteQueryOptions) => {
    return members.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
members.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: members.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
members.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: members.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
const membersForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: members.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
membersForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: members.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\MemberController::__invoke
* @see app/Http/Controllers/Creator/MemberController.php:25
* @route '/app/creator/members'
*/
membersForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: members.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

members.form = membersForm

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
export const contributions = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contributions.url(options),
    method: 'get',
})

contributions.definition = {
    methods: ["get","head"],
    url: '/app/creator/contributions',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
contributions.url = (options?: RouteQueryOptions) => {
    return contributions.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
contributions.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contributions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
contributions.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contributions.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
const contributionsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contributions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
contributionsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contributions.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\ContributionController::contributions
* @see app/Http/Controllers/Creator/ContributionController.php:19
* @route '/app/creator/contributions'
*/
contributionsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: contributions.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

contributions.form = contributionsForm

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
export const inbox = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: inbox.url(options),
    method: 'get',
})

inbox.definition = {
    methods: ["get","head"],
    url: '/app/creator/inbox',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
inbox.url = (options?: RouteQueryOptions) => {
    return inbox.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
inbox.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: inbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
inbox.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: inbox.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
const inboxForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: inbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
inboxForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: inbox.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\InboxController::inbox
* @see app/Http/Controllers/Creator/InboxController.php:27
* @route '/app/creator/inbox'
*/
inboxForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: inbox.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

inbox.form = inboxForm

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
export const payouts = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payouts.url(options),
    method: 'get',
})

payouts.definition = {
    methods: ["get","head"],
    url: '/app/creator/payouts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
payouts.url = (options?: RouteQueryOptions) => {
    return payouts.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
payouts.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: payouts.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
payouts.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: payouts.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
const payoutsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payouts.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
payoutsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payouts.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\PayoutController::payouts
* @see app/Http/Controllers/Creator/PayoutController.php:24
* @route '/app/creator/payouts'
*/
payoutsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: payouts.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

payouts.form = payoutsForm

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
export const team = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: team.url(options),
    method: 'get',
})

team.definition = {
    methods: ["get","head"],
    url: '/app/creator/team',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
team.url = (options?: RouteQueryOptions) => {
    return team.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
team.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: team.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
team.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: team.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
const teamForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: team.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
teamForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: team.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\TeamInvitationController::team
* @see app/Http/Controllers/Creator/TeamInvitationController.php:25
* @route '/app/creator/team'
*/
teamForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: team.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

team.form = teamForm

const creator = {
    setup: Object.assign(setup, setup),
    payment: Object.assign(payment, payment),
    platform: Object.assign(platform, platform),
    dashboard: Object.assign(dashboard, dashboard074181),
    onboardingTour: Object.assign(onboardingTour, onboardingTour),
    members: Object.assign(members, members79483b),
    contributions: Object.assign(contributions, contributions49f328),
    inbox: Object.assign(inbox, inbox43de3a),
    campaigns: Object.assign(campaigns, campaigns),
    automations: Object.assign(automations, automations),
    plans: Object.assign(plans, plans),
    profile: Object.assign(profile, profile),
    payouts: Object.assign(payouts, payouts),
    community: Object.assign(community, community),
    posts: Object.assign(posts, posts),
    bundles: Object.assign(bundles, bundles),
    team: Object.assign(team, team4b9005),
}

export default creator